<template>
  <div class="other-meeting-detail">
    <el-form ref="otherRef" :model="otherMeetingModel">
      <el-form-item label="会议类型：">
        <el-checkbox :value="true">其他专题会议</el-checkbox>
      </el-form-item>
      <el-form-item label="开始时间：">
        <el-input :value="otherMeetingModel.startTime" readonly></el-input>
      </el-form-item>
      <el-form-item label="结束时间：">
        <el-input :value="otherMeetingModel.endTime" readonly></el-input>
      </el-form-item>
      <el-form-item label="会议地点：">
        <el-input :value="otherMeetingModel.room" readonly></el-input>
      </el-form-item>
      <el-form-item label="会议议题：">
        <el-input :value="otherMeetingModel.title" readonly></el-input>
      </el-form-item>
      <el-form-item label="会议类别：">
        <el-checkbox
          v-for="(item, index) in typeList"
          :value="isTypeChecked(item)"
          :key="index"
          >{{ item.value }}</el-checkbox
        >
      </el-form-item>
      <el-form-item label="会议内容：">
        <el-input
          type="textarea"
          :value="otherMeetingModel.content"
          :rows="6"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="出席人员：">
        <div class="el-input tag-wrapper">
          <el-tag
            v-for="tag in otherMeetingModel.joinWorkList"
            :key="tag.id"
            style="margin-right: 5px;"
            >{{ tag.displayName || tag.name }}</el-tag
          >
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-wrapper">
      <el-button type="info" @click="submitOtherMeeting">关闭</el-button>
    </div>
  </div>
</template>

<script>
import {
  getOtherConferenceTypeList,
  getConferenceDetail,
} from "@/services/conferenceServices";
import Constants from "@/utils/consts";
import { formatTimeStr } from "@/utils/index";
import { goBackApprove } from "@/page/approveComponents/approve";
export default {
  name: "OtherMeetingDetail",
  data() {
    return {
      id: undefined,
      otherMeetingModel: {},
      typeList: [], // 会议类型
    };
  },
  methods: {
    onActive() {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      
      if (this.id) {
        this.getMeetingDetail().then(() => {
          this.initMeetingTypeList();
        }).catch(() => {});
      } else {
        this.$alert(Constants.Err_Msg, "提示");
      }
    },
    initMeetingTypeList() {
      getOtherConferenceTypeList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.typeList = res.data || [];
          }
        })
        .catch((error) => {});
    },

    getMeetingDetail() {
      return getConferenceDetail({ conferenceId: this.id })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let data = res.data || {};
            // 这里只是展示，所以对数据进行了处理
            let { joinWorkJson } = data;
            data.joinWorkList = JSON.parse(joinWorkJson);
            this.otherMeetingModel = data;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(() => {});
    },

    isTypeChecked(item) {
      let value = this.otherMeetingModel.typeMap[item.label];
      return !!value;
    },
    submitOtherMeeting() {
      // 关闭窗口
      if (this.tabRouteParam.approveFlag) {
        goBackApprove(this.tabRouteParam.approveFlag, "otherMeetingDetail");
      } else {
      this.bus.$emit("tabClose", "otherMeetingDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "other-meeting",
      });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.other-meeting-detail {
  background-color: white;
  padding: 20px 20px 50px;
  width: 72%;
}

/deep/ .el-form-item__content {
  display: flex;

  /deep/.el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

.btn-wrapper {
  margin-top: 20px;
  text-align: center;
}
</style>
